import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Star, Flame, Trophy } from "lucide-react";
import { BADGE_LABELS, fetchProgress } from "@/lib/rewards";

export default function ProgressCard() {
  const [p, setP] = useState(null);

  const load = () => fetchProgress().then(setP).catch(() => {});
  useEffect(() => {
    load();
    const onRefresh = () => load();
    window.addEventListener("kks:progress-refresh", onRefresh);
    return () => window.removeEventListener("kks:progress-refresh", onRefresh);
  }, []);

  if (!p) return null;
  return (
    <Card className="border-amber-200 bg-amber-50/40" data-testid="progress-card">
      <CardContent className="py-4 space-y-3">
        <div className="flex items-center justify-between">
          <div className="text-xs uppercase font-semibold text-amber-700 tracking-wide">
            My progress
          </div>
          <Trophy className="h-4 w-4 text-amber-600" />
        </div>
        <div className="grid grid-cols-3 gap-2 text-center">
          <Stat label="Points" value={p.total_points} testid="progress-points" />
          <Stat
            label="Stars"
            value={`${p.total_stars} ⭐`}
            testid="progress-stars"
          />
          <Stat
            label="Streak"
            value={
              <span className="inline-flex items-center gap-1">
                {p.current_streak_days}
                <Flame className="h-4 w-4 text-orange-500" />
              </span>
            }
            testid="progress-streak"
          />
        </div>
        {p.badges?.length > 0 && (
          <div>
            <div className="text-[10px] uppercase font-semibold text-stone-500 mb-1">
              Badges
            </div>
            <div className="flex flex-wrap gap-1.5" data-testid="progress-badges">
              {p.badges.map((b) => {
                const meta = BADGE_LABELS[b] || { label: b, emoji: "🏅" };
                return (
                  <Badge
                    key={b}
                    variant="outline"
                    className="bg-white border-amber-300 text-stone-800 gap-1"
                    data-testid={`badge-${b}`}
                  >
                    <span aria-hidden>{meta.emoji}</span> {meta.label}
                  </Badge>
                );
              })}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

function Stat({ label, value, testid }) {
  return (
    <div data-testid={testid}>
      <div className="text-xl font-semibold text-stone-900">{value}</div>
      <div className="text-[10px] uppercase text-stone-500 mt-0.5">{label}</div>
    </div>
  );
}
